<template>
  <div class="mainBox">
    <div class="mainCon">
      <stu-main-title></stu-main-title>

      <div class="content">
        <template v-if="tableData.length">
          <el-alert
            title="同学您好，管理员已为您申请退费，5个工作日内退费金额返回您的账户，请您及时关注！"
            type="success"
            style="margin-bottom: 16px;"
            v-if="refundPayFlag && paymentType != 2"
          ></el-alert>
          <el-alert
            title="同学您好，管理员已为您申请退费，请您联系院校老师查看退费信息！"
            type="success"
            style="margin-bottom: 16px;"
            v-if="refundPayFlag && paymentType == 2"
          ></el-alert>

          <!-- 线下缴费 -->
          <div v-if="planInfo.payType == 2" class="imgBox">
            <img :src="payImg" alt="" class="mb20 mt20 picArea" v-if="payImg"/>
            <div v-if="pay_type2Money > 0" class="courseAndMoney">
              <p><span class="coruseTitle">报考科目：</span></p>
              <p v-for="item in tableData" :key="item.courseId">
                <span>{{ item.course }}：</span>
                <b>{{ item.money }}</b>
                &nbsp;&nbsp;元
              </p>
              <p>
                <span class="totalMoney">缴费总额：</span>
                <b class="col_red">{{ pay_type2Money }}</b>
                &nbsp;&nbsp;元
              </p>
              <p>
                <span class="coruseTitle" style="margin-top: 24px;" v-if="payRemarkList.length > 0">缴费说明：</span>
              </p>
              <p
                class="payText"
                v-for="(item, index) in payRemarkList"
                :key="index"
              >
                {{ `${index + 1}.${item}` }}
              </p>
            </div>
            <p class="col_red font_16" style="margin-top: 16px;font-weight: 700;">
              缴费告知说明：若已经缴费请关注缴费状态，人工核验后会自动更新缴费状态。
            </p>
          </div>

          <ots-table
            v-else
            :tableOption="tableOption"
            :tableHeader="tableHeader"
            :tableData="tableData"
            @handleSelectionChange="stubachOper"
          ></ots-table>
        </template>
        <div v-else class="imgBox">
          <img src="@/assets/stuImg/nothing.png" alt="" />
          <span class="col_grayQ">暂无需要缴费的信息</span>
        </div>
      </div>
    </div>

    <div v-if="tableData.length && planInfo.payType != 2 && refundPayFlag != 1">
      <stu-foot>
        <div class="bottomLine">
          <div></div>
          <div class="lineRight" v-if="planInfo.state !== 0">
            <span class="mr5">缴费总额:</span>
            <span class="col_orange f24 mr20">{{ totalMoney }}</span>
            <el-button round type="primary" @click="goPay">立即支付</el-button>
          </div>
        </div>
      </stu-foot>
    </div>
    <form id="cedupayForm" name="cedupayForm" method="post">
      <input type="hidden" id="cdata" name="cdata" />
      <input type="hidden" id="merchantNo" name="merchantNo" />
    </form>
  </div>
</template>
<script>
import StuFoot from "../components/stuFoot.vue";
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
import {
  selectPayInfoFn,
  payFn,
  beforePayFn,
  getTenantPayTypeApi
} from "@/http/modules/student/payment";
import paySet from "@/http/paySet";
export default {
  components: {
    StuFoot,
  },
  name: "payFee",
  data() {
    return {
      pay_cdata: "",
      pay_merchantNo: "",
      payUrl: "",
      checkAll: false,
      payDialog: false,
      iframeData: "",
      selectList: [],
      tableOption: {
        // multiple:true,
        // selectTable: function (row) {
        //     return row.isPay == "未缴费"
        // }
      },
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "科目名称",
          prop: "course",
        },
        {
          title: "报考费用(元)",
          prop: "money",
        },
        {
          title: "缴费状态",
          prop: "isPay",
        },
        // {
        //     title: '缴费状态',
        //     type:"buttons",
        //     width:"60",
        //     btnList:[
        //         {
        //             title: "下载合格证",
        //             click: this.deleteCoursePaper
        //         },
        //         {
        //             title: "下载成绩单",
        //             click: this.deleteCoursePaper
        //         },
        //     ]
        // },
      ],
      tableData: [],
      payForm: {
        courseId: "",
        planId: "",
        amount: "",
        returnUrl: "",
      },
      tenant: "",
      payImg: "",
      paymentType: "",
      paymentText: "",
      pay_type2Money: "",
      planInfo: {},
      refundPayFlag: "",
    };
  },
  computed: {
    totalMoney() {
      let money = this.selectList
        .filter((item) => item.isPay == "未缴费")
        .reduce((a, b) => a + b.money, 0);
      return parseFloat(money).toFixed(2);
    },
    // 缴费说明
    payRemarkList() {
      return this.paymentText ? this.paymentText.split(";") : [];
    },
  },
  watch: {
    payUrl: () => {
      // document.getElementById('cedupayForm').submit(function(event) {
      //     console.log('------ok-------');
      // })
    },
  },
  created() {
    this.getPayData();
    this.tenant = window.localStorage.getItem("tenant");
    // this.payImg = paySet(this.tenant)
  },

  mounted(){
    this.selectUserInfo();
  },

  methods: {
    /**
     * @param { 查询是否退费 }
     */
    async selectUserInfo() {
      let stuIds = JSON.parse(localStorage.getItem("userInfo") || "{}").id;
      let planId = window.sessionStorage.getItem("planId");
      let params = { planId, stuIds };
      const { data } = await this.$api.applyManage.selectOneSignUp(params);
      this.refundPayFlag = data.refundPayFlag;
    },



    /**
     * @param { 获取批次信息 }
     */
    async getPayData() {
      let payTypeList = ["12", "27"];

      const { data: plan } = await getCurrentPlanFn({
        planId: this.getCurrentGlobalPlanId(),
      });

      const {data: payCode} = await getTenantPayTypeApi();

      this.paymentType = payTypeList.includes(payCode) || plan.payType == 2 ? 2 : 1;
  
      this.payForm.planId = plan.id;
      this.planInfo = plan;

      if (plan.payType == 2) {
        this.payImg = plan.payPic;
        this.paymentText = plan.payText;
      }

      this.getPayList();
    },
    getPayList() {
      selectPayInfoFn({
        planId: this.getCurrentGlobalPlanId(),
      }).then(({ data }) => {
        if (data) {
          this.tableData = data;
          this.pay_type2Money = data
            .filter((item) => item.isPay == "未缴费")
            .reduce((a, b) => a + b.money, 0);
        } else {
          this.tableData = [];
        }
      });
    },
    stubachOper(val) {
      let idList = [];
      val.forEach((item) => {
        idList.push(item);
      });
      this.selectList = idList;
    },
    randomString(len) {
      len = len || 32;
      let $chars =
        "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      let maxPos = $chars.length;
      let pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    dealStr(str) {
      return window.encodeURI(window.btoa(str));
    },
    getReturnUrl() {
      //his.payForm.returnUrl = window.location.href
      // this.payForm.returnUrl = "https://afdt.chinaedu.net/otssign/api/sign/payment/redirect";

      // x=sign    q=租户code    f=随机字符   z=随机字符   d=随机字符
      let urlParam = {
        x: this.dealStr("sign"),
        q: this.dealStr(this.tenant),
        f: this.dealStr(this.randomString(7)),
        z: this.dealStr(this.randomString(8)),
        d: this.dealStr(this.randomString(9)),
      };

      let paramStrList = [];
      for (let key of Object.keys(urlParam)) {
        paramStrList.push(`${key}=${urlParam[key]}`);
      }
      let paramStr = paramStrList.join("&");
      return `${window.location.origin}/otssign/api/sign/payment/redirect?${paramStr}`;
    },
    async goPay() {
      let temp = this.selectList.filter((item) => item.isPay == "未缴费");
      if (!temp.length) {
        this.$message.warning("请选择未缴费课程");
        return;
      }
      let courseId = temp.map((item) => item.courseId).join();
      // 新增参数
      let payTerminal = 1;

      const { data } = await beforePayFn({
        courseId,
        payTerminal,
        planId: this.getCurrentGlobalPlanId(),
      });

      if (data) {
        this.payKey = data.st;
        if (data.operateStatus == 1) {
          //出弹窗
          this.$confirm(
            `您于${data.date}尝试过支付，请确认是否已支付？若已支付请耐心等待支付结果。`,
            "系统提示",
            {
              confirmButtonText: "未支付",
              cancelButtonText: "已支付",
              type: "warning",
            }
          )
            .then(async () => {
              // 未支付
              this.dealPay();
            })
            .catch(() => {
              // 已支付
              this.getPayList();
            });
        } else {
          this.dealPay();
        }
      }
    },
    async dealPay() {
      let pay_param = {
        returnUrl: this.getReturnUrl(),
        st: this.payKey,
      };
      const { data } = await payFn(pay_param);
      this.pay_cdata = data.cdata;
      this.payUrl = data.payCenterGateway;
      this.pay_merchantNo = data.merchantNo;
      document.getElementById("cedupayForm").action = data.payCenterGateway;
      document.getElementById("cdata").value = data.cdata;
      document.getElementById("merchantNo").value = data.merchantNo;
      let param = {
        payCenterGateway: data.payCenterGateway,
        cdata: data.cdata,
        merchantNo: data.merchantNo,
      };
      // alert(JSON.stringify(param))
      // return
      document.getElementById("cedupayForm").submit();
    },
  },
};
</script>
<style lang="less" scoped>
.mainBox {
  width: 100%;
  min-width: 700pt;
  background-color: #fff;
  border-radius: 8px;
}
.mainCon {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 16px;
  width: 100%;
  background: rgba(255, 255, 255, 0.93);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .content {
    padding-top: 20px;
    .imgBox {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 80px;
    }
  }
}
.font_16 {
  font-size: 16px;
}
.courseAndMoney {
  width: 400px;
  font-size: 16px;
  .payText {
    margin: 8px 0;
    text-align: left;
    padding-left: 16px;
    box-sizing: border-box;
  }
  p {
    line-height: 24px;
    .coruseTitle {
      font-weight: 700;
      text-align: left;
    }
    .totalMoney {
      font-weight: 700;
    }
    span {
      display: inline-block;
      min-width: 225px;
      text-align: right;
    }
  }
}
.bottomLine {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lineRight {
    display: flex;
    align-items: center;
  }
}
/deep/ .el-table th,
.el-table tr {
  background-color: #ebecff !important;
}
.picArea {
  width: 260px;
  height: 260px;
}
</style>
